import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SolutionTokenService } from '../services/solution-token.service';
import { rutaInicial } from './capability.guard';

/**
 * Saca del login a quien ya tiene sesión. El destino depende del rol: mandarlo
 * fijo al panel principal hacía aterrizar ahí al técnico, que no puede verlo.
 */
export const guestGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const solutionToken = inject(SolutionTokenService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  // Si el token no se puede emitir se decide con lo que haya: expulsar a un
  // usuario legítimo por un problema de red sería peor.
  await solutionToken.getToken().catch(() => null);
  return router.parseUrl(rutaInicial(solutionToken));
};
